"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styles = __importStar(require("./CheckboxFilter.css"));
const Checkbox_1 = __importDefault(require("@mulesoft/anypoint-components/raw/components/Checkbox"));
const constants_1 = require("../../constants");
const CheckboxFilter = (props) => {
    return (React.createElement("div", { className: `${styles.checkboxFilter} ${constants_1.ANG_CSS_PREFIX}-checkbox-filter` },
        React.createElement(Checkbox_1.default, { checked: props.value === 'true', indeterminate: props.value === '', onChange: props.handleBooleanChange, className: styles.indeterminate, disabled: props.disabled })));
};
exports.default = CheckboxFilter;
